
import io from 'socket.io-client';

const currentLocation = window.location;
console.log(currentLocation.origin,"currentLocation.origin");

const sockets = io(currentLocation.origin); // Replace with your server URL
 
export default sockets;
